/**
 * Further sub classification of the CommissionAmountType(2641).
 * tag: 2725
 * @readonly
 * @enum {number} (int)
 */
export enum CommissionAmountSubType {
  /** Research payment account (RPA) */
  ResearchPaymentAccount = 0,
  /** Commission sharing agreement (CSA) */
  CommissionSharingAgreement = 1,
  OtherTypeResearchPayment = 2,
}
